// Explosión de confeti en canvas, sin dependencias. Se usa al marcar una
// operación como "vendida" en /escenarios (clic en el martillo).

type Particula = {
  x: number;
  y: number;
  vx: number;
  vy: number;
  ancho: number;
  alto: number;
  color: string;
  rot: number;
  vrot: number;
  vida: number; // 1 → 0
};

const COLORES = [
  "#f43f5e", "#f59e0b", "#10b981", "#3b82f6",
  "#8b5cf6", "#ec4899", "#facc15", "#22d3ee",
];

/** Dispara una explosión de confeti centrada en (x, y) — coordenadas de viewport. */
export function confettiBurst(x: number, y: number, cantidad = 140) {
  const canvas = document.createElement("canvas");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  Object.assign(canvas.style, {
    position: "fixed",
    inset: "0",
    pointerEvents: "none",
    zIndex: "9999",
  } as CSSStyleDeclaration);
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    canvas.remove();
    return;
  }

  const particulas: Particula[] = Array.from({ length: cantidad }, () => {
    const angulo = Math.random() * Math.PI * 2;
    const velocidad = 5 + Math.random() * 11;
    return {
      x,
      y,
      vx: Math.cos(angulo) * velocidad,
      vy: Math.sin(angulo) * velocidad - 4, // sesgo hacia arriba: explosión
      ancho: 5 + Math.random() * 5,
      alto: 8 + Math.random() * 7,
      color: COLORES[Math.floor(Math.random() * COLORES.length)],
      rot: Math.random() * Math.PI,
      vrot: (Math.random() - 0.5) * 0.4,
      vida: 1,
    };
  });

  let anterior = performance.now();
  const paso = (ahora: number) => {
    const dt = Math.min((ahora - anterior) / 16.67, 3); // normalizado a ~60fps
    anterior = ahora;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    let vivas = 0;
    for (const p of particulas) {
      p.vida -= 0.008 * dt;
      if (p.vida <= 0) continue;
      vivas++;
      p.vx *= 0.985;
      p.vy = p.vy * 0.985 + 0.35 * dt; // gravedad
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.vrot * dt;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = Math.min(1, p.vida * 3);
      ctx.fillStyle = p.color;
      // escala en Y con el giro para simular papelito volteándose
      ctx.fillRect(-p.ancho / 2, (-p.alto / 2) * Math.sin(p.rot * 3), p.ancho, p.alto * Math.abs(Math.sin(p.rot * 3)) + 2);
      ctx.restore();
    }

    if (vivas > 0) {
      requestAnimationFrame(paso);
    } else {
      canvas.remove();
    }
  };
  requestAnimationFrame(paso);
}
